import useTranslator from "../../hooks/useTranslator";
import Form from "react-bootstrap/Form";
import OTPInput from "otp-input-react";
import Cancelimg from "../../assets/img/cancel-01.svg";
import { useCallback, useEffect, useRef, useState } from "react";
import axiosInstance from "../../services/authWrapper";
import { toast } from "../../helper/common";
import LoadingSpinner from "../../components/LoadingSpinner";

const EnterOtpModal = ({
  otp,
  setOtp,
  isGuarantor,
  onClose,
  handleSubmitEditedUser,
  showResend,
  showTimer,
  sendOtpFun,
  verifyOTPHandler,
  verifyOtpLoading,
  email,
  isDummySignup,
  setStep,
}) => {
  const { _t } = useTranslator();
  const [otpSubmitLoading, setOtpSubmitLoading] = useState(false);
  const submittedOtpRef = useRef("");
  const otpWrapperRef = useRef(null);
  const wasLoadingRef = useRef(false);
  const otpinputChange = (e) => {
    setOtp(e);
  };

  const focusLastInput = useCallback(() => {
    if (otpWrapperRef.current) {
      const inputs = otpWrapperRef.current.querySelectorAll("input");
      if (inputs.length > 0) inputs[inputs.length - 1].focus();
    }
  }, []);

  useEffect(() => {
    const isLoading = otpSubmitLoading || verifyOtpLoading;
    if (wasLoadingRef.current && !isLoading) {
      focusLastInput();
    }
    wasLoadingRef.current = isLoading;
  }, [otpSubmitLoading, verifyOtpLoading, focusLastInput]);

  const verifyOTP = useCallback(async () => {
    const userid = localStorage.getItem("saveduserid");
    const usertype = localStorage.getItem("usertype");
    setOtpSubmitLoading(true);
    await axiosInstance
      .put(
        `${process.env.REACT_APP_SERVER_URL}/users/otp-verify/${userid}`,
        { type: usertype, otp: otp },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {
        if (res?.data?.status === "verified") {
          handleSubmitEditedUser(true);
        }
      })
      .catch((err) => {
        let serverResponse = err;
        toast.error(serverResponse.response.data.msg);
      })
      .finally(() => {
        setOtpSubmitLoading(false);
      });
  }, [handleSubmitEditedUser, otp]);

  const handleVerifyOTP = useCallback(
    (event) => {
      (verifyOTPHandler ? verifyOTPHandler : verifyOTP)(event);
    },
    [verifyOTPHandler, verifyOTP]
  );

  useEffect(() => {
    if ((otp ?? "").length < 6) {
      submittedOtpRef.current = "";
      return;
    }

    if (
      (otp ?? "").length === 6 &&
      !(otpSubmitLoading || verifyOtpLoading) &&
      submittedOtpRef.current !== otp
    ) {
      submittedOtpRef.current = otp;
      handleVerifyOTP({ preventDefault: () => {} });
    }
  }, [handleVerifyOTP, otp, otpSubmitLoading, verifyOtpLoading]);

  return (
    <div
      className={`approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${
        isGuarantor ? "guarantorBg" : ""
      }`}
      style={{ zIndex: 99 }}
    >
      <div
        className="popup-content2 position-relative popup-content bg-white required-doc-popup enterOtpPopup"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="d-flex custom-mb-3 align-items-center justify-content-between">
          <h2 className="headerOtp">{_t("checkYourEmailForOtp")}</h2>
          <img
            src={Cancelimg}
            alt="icon"
            className="canceicon"
            onClick={onClose}
          />
        </div>
        <p>{_t("anOtpHasBeenSentToYourEmailPleaseCheck")}</p>
        <p className="fw-bold">{email}</p>
        <Form
          onKeyDown={(e) => {
            if (
              e.key === "Enter" &&
              (otp ?? "").length === 6 &&
              !(otpSubmitLoading || verifyOtpLoading)
            ) {
              handleVerifyOTP(e);
            }
          }}
          className="loginform otp-Verification otpVerificationModal"
        >
          <div ref={otpWrapperRef}>
            <OTPInput
              className="forminput"
              value={otp}
              onChange={otpinputChange}
              autoFocus
              OTPLength={6}
              otpType="number"
              disabled={otpSubmitLoading || verifyOtpLoading}
            />
          </div>
        </Form>
        <div className="d-flex align-items-center justify-content-center mb-2">
          {otpSubmitLoading || verifyOtpLoading ? (
            <LoadingSpinner
              size={"1.111vw"}
              color="#253837"
              borderWidth={1}
              className="docs-loading-spinner"
            />
          ) : null}
        </div>
        {showResend ? (
          <>
            <p className="notFindText">
              {_t("cannotFindOtpEmailPleaseCheckSpamAsWellOrTryAgain")}
            </p>
            <p
              onClick={sendOtpFun}
              className="hover-underline resendButton cursor-pointer"
              style={{
                pointerEvents:
                  otpSubmitLoading || verifyOtpLoading ? "none" : "auto",
                opacity: otpSubmitLoading || verifyOtpLoading ? 0.5 : 1,
              }}
            >
              {_t("resend")}
            </p>
          </>
        ) : (
          <p className="resendOtpText custom-gap-2 align-items-center justify-content-center">
            {_t("resentOtpIn")}
            <span>{showTimer}s</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default EnterOtpModal;
